import AbstractAccountGroup from "./AbstractAccountGroup.js";
import Account from "../Account.js";

/**
 * `intervalAccountGroup` represent a chart of accounts interval.
 * It contains a list of intervals of account numbers.
 *
 * @param {object[]} spec.intervals - Intervals of the group
 */
export default class IntervalAccountGroup extends AbstractAccountGroup {
	constructor({ intervals = [] } = {}) {
		super(...arguments);

		this._intervals = intervals;
	}

	getIntervals() {
		return this._intervals;
	}

	setIntervals(string) {
		this._intervals = this.constructor.parseInterval(string);
	}

	getName() {
		return this.getIntervalsString();
	}

	getIntervalsString() {
		return this._intervals
			.map((interval) => `${interval.start}-${interval.end}`)
			.join(",");
	}

	matchString(string) {
		return this.hasAccount(new Account({ number: string }));
	}

	hasAccounts() {
		return this._intervals.length > 0;
	}

	hasAccount(account) {
		return !!this._intervals.find((interval) =>
			account.isInInterval(interval),
		);
	}

	accept(visitor) {
		return visitor.visitIntervalAccountGroup(this);
	}

	canBeAddedTo(group) {
		return group.canAddInterval(this);
	}

	canBeRemoved() {
		return true;
	}

	canAdd() {
		// an interval can not have children
		return false;
	}

	isInterval() {
		return true;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.intervals = this._intervals;

		return properties;
	}

	static getType() {
		return "AccountIntervalGroup";
	}

	/**
	 * Parse an interval (or multiple intervals) string of the form
	 * "100-120,2000-3000".
	 *
	 * Return an array of intervals, each interval being a tuple {start,
	 * end}.
	 */
	static parseInterval(intervalString) {
		return intervalString
			.trim()
			.split(",")
			.filter(Boolean)
			.map((interval) => {
				const [start, end] = interval
					.trim()
					.split("-")
					.map((number) => number && number.trim());
				return { start, end: end || start };
			});
	}
}
